import { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { retrieveSchema } from '../../../utils/schemaUtils';
import { toIdSchema } from '../../../utils/idUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import AddButton from '../shared/AddButton';
import RemoveButton from '../shared/RemoveButton';
import Toolbar from '../shared/Toolbar';
import SchemaField from '../SchemaField';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ArrayFieldItems extends Component {
  render() {
    const {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      autoFocus,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      canAddItem,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      canRemoveItem,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      definitions,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      disabled,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      errorSchema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      formData,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      idPrefix,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      idSchema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      onAddItemClick,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      onRemoveItemClick,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      onChangeForIndex,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      readOnly,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      registry,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      schema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      showAddButton
    } = this.props;
    const has = {
      remove: canRemoveItem(formData)
    };
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    has.toolbar = Object.keys(has).some(k => has[k]);
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      formData.map((item, index) => {
        const itemSchema = retrieveSchema(schema.items, definitions, item);
        const itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
        const itemIdPrefix = `${idSchema.$id}_${index}`;
        const itemIdSchema = toIdSchema(itemSchema, itemIdPrefix, definitions, item, idPrefix);
        return /*#__PURE__*/_jsxs(UIFlex, {
          align: "start",
          justify: "between",
          className: "array-field-items m-bottom-2",
          children: [/*#__PURE__*/_jsx(UIBox, {
            grow: 1,
            shrink: 1,
            basis: "100%",
            children: /*#__PURE__*/_jsx(SchemaField
            /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
              autoFocus: autoFocus && index === formData.length - 1,
              collapsed: false,
              disabled: disabled,
              errorSchema: itemErrorSchema,
              formData: item,
              idSchema: itemIdSchema,
              onChange: onChangeForIndex(index),
              readOnly: readOnly,
              registry: registry,
              schema: itemSchema,
              parentSchemaType: schema.type
            })
          }), /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
          has.toolbar && /*#__PURE__*/_jsx(UIBox, {
            className: "m-left-6",
            children: /*#__PURE__*/_jsx(Toolbar, {
              children: has.remove && /*#__PURE__*/_jsx(RemoveButton, {
                "data-test-id": "array-item-remove",
                className: "p-y-3",
                onClick: onRemoveItemClick(index),
                disabled: disabled || readOnly,
                tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "developer-docs-shared-components.params.body.removeTestValue"
                })
              })
            })
          })]
        }, index);
      }), showAddButton && canAddItem(formData) &&
      /*#__PURE__*/
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      _jsx(AddButton, {
        onClick: onAddItemClick,
        disabled: disabled || readOnly,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.params.body.addTestValue"
        })
      })]
    });
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
ArrayFieldItems.propTypes = {
  autoFocus: PropTypes.bool.isRequired,
  canAddItem: PropTypes.func.isRequired,
  canRemoveItem: PropTypes.func.isRequired,
  definitions: PropTypes.object,
  disabled: PropTypes.bool,
  errorSchema: PropTypes.object,
  formData: PropTypes.array.isRequired,
  idPrefix: PropTypes.string,
  idSchema: PropTypes.object.isRequired,
  onAddItemClick: PropTypes.func.isRequired,
  onRemoveItemClick: PropTypes.func.isRequired,
  onChangeForIndex: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  registry: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  showAddButton: PropTypes.bool.isRequired
};